import { API_URL } from '../../utils/constants';
import request from '../request';

export default {
  importAnUpload: async (id) => {
    return request(`${API_URL}/products/imports/upload-and-import-logistics/${id}`, 'post');
  },

  exportLogistics: async (string) => {
    const body = JSON.stringify(string);

    return request(`${API_URL}/products/imports/export-logistics`, 'post', body, null, {
      responseType: 'arraybuffer',
    });
  },

  exportOffer: async (body) => {
    return request(`${API_URL}/products/imports/export-offer`, 'post', body, null, {
      responseType: 'arraybuffer',
    });
  },

  importAnUploadSizes: async (id) => {
    return request(`${API_URL}/products/imports/upload-and-import-sizes/${id}`, 'post');
  },

  exportSizes: async () => {
    return request(`${API_URL}/products/imports/export-sizes`, 'get', null, null, {
      responseType: 'arraybuffer',
    });
  },

  exportSupplierData: async () => {
    return request(`${API_URL}/products/imports/export-supplier-data`, 'get', null, null, {
      responseType: 'arraybuffer',
    });
  },

  importAnUploadSupplierData: async (id) => {
    return request(`${API_URL}/products/imports/upload-and-import-supplier-data/${id}`, 'post');
  },

  importMatchingSheet: async (id) => {
    return request(`${API_URL}/products/imports/import-chocolate-matching`, 'post');
  },

  getMatches: async (id) => {
    return request(`${API_URL}/products/imports/get-matches`, 'post');
  },

  saveMatch: async (item) => {
    const body = JSON.stringify(item);

    return request(`${API_URL}/products/imports/save-match/${item.id}`, 'post', body);
  },

  noMatch: async (id) => {
    return request(`${API_URL}/products/imports/no-match/${id}`, 'post');
  },
};
